import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import ProfileCard from "./ProfileCard";
import Preview1 from "./BusinessBox/Preview1";
import Preview2 from "./BusinessBox/Preview2";
import Carousel from "react-material-ui-carousel";
import CustomLoader from "../../../sharedcomponents/CustomLoader";
import MainWheel from "./MainWheel";
import AllWheels from "./AllWheels";
import { ASSETS } from "../../../utils/config";
import { isEmpty } from "lodash";
import { Box, IconButton, Snackbar, Stack, Typography } from "@mui/material";
import Sidebar from "./SideBar";
import CloseIcon from "@mui/icons-material/Close";
import GalleryLoader from "./GalleryLoader";
import { TextView } from "../../../components";
import { colors } from "../../../utils";
import MobileError from "./MobileError";

const Logo = styled.img`
  height: 40px;
  width: 42px;
`;

const TopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 10px;
  padding-bottom: 5px;
`;

const MenuBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  background-color: #ffffff;
  cursor: pointer;
`;

const CarouselContainer = styled.div`
  border-radius: 10px;
  margin: 10px;
  padding: 10px;
  padding-bottom: 0px;
  position: relative;
  z-index: 1000;
`;

const Container = styled.div`
  width: 25vw;
`;

const SearchContainer = styled.div`
  display: flex;
  flex-direction: row;
  background-color: white;
  padding: 5px 10px;
  border-radius: 10px;
  height: 5vh;
  align-items: center;
  margin: 10px;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
`;
const SearchIcon = styled.img`
  margin-right: 10px;
  width: 20px;
  height: 20px;
`;

const TextInput = styled.input`
  outline: none;
  border: none;
  width: 100%;
  background-color: white;
`;

function MobileView({
  profileData,
  businessBoxData,
  isLoading,
  wheelType,
  mainName,
  authorName,
  data,
  handleCloneWheel,
  publicWheels,
  onHamburgerIconClick,
}) {
  const initialValues = useMemo(
    () => (!isEmpty(businessBoxData) ? businessBoxData : null),
    [businessBoxData]
  );

  const referral_code = data?.user_profile?.referral_code;
  const [open, setOpen] = useState(false);
  const [openClipboard, setOpenClipboard] = useState(false);
  const [filteredPublicWheels, setFilteredPublicWheels] = useState([]);

  useEffect(() => {
    setFilteredPublicWheels(publicWheels);
  }, [publicWheels]);

  const [isMediaOpen, setIsMediaOpen] = useState(false);
  const [searchText, setSearchText] = useState("");

  const [isLandscape, setIsLandscape] = useState(
    window.innerWidth > window.innerHeight
  );

  const toggleSideBar = () => {
    setOpen(!open);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenClipboard(false);
  };

  useEffect(() => {
    const handleOrientationChange = () => {
      console.log("orientation changed");
      setIsLandscape(window.innerWidth > window.innerHeight);
    };

    window.addEventListener("resize", handleOrientationChange);
    return () => {
      window.removeEventListener("resize", handleOrientationChange);
    };
  }, []);

  const handleSearch = () => {
    if (searchText === "") {
      setFilteredPublicWheels(publicWheels);
      return;
    }

    const newArray = filteredPublicWheels.filter((wheel) => {
      const titleLower = wheel?.wheel_name?.toLowerCase();
      const searchTextLower = searchText.toLowerCase();
      return titleLower.includes(searchTextLower);
    });

    setFilteredPublicWheels(newArray);
  };

  useEffect(() => {
    handleSearch(searchText);
  }, [searchText]);

  console.log(filteredPublicWheels, publicWheels, searchText, "AAAAAAA");

  if (isLandscape) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          bgcolor: "#F6F7F9",
        }}
      >
        <Stack
          sx={{ justifyContent: "center", alignItems: "center", width: "50vw" }}
        >
          <img
            src={ASSETS.iyugaLogo}
            className="img-fluid"
            alt="Clones"
            width="84"
            height="84"
          />
          <Typography
            sx={{ p: 4, color: "#123051", fontSize: 20, fontWeight: "700" }}
            variant="h6"
            color="text.secondary"
            textAlign="center"
          >
            Rotate your device to portrait mode for an optimised viewing
            experience.
          </Typography>
        </Stack>
      </Box>
    );
  } else {
    return (
      <>
        {isLoading ? (
          // <CustomLoader show={true} />
          <>
            <TopRow>
              <Logo alt="logo" src={ASSETS.MobileLogo} />
              <MenuBox onClick={toggleSideBar}>
                <img src={ASSETS.Hamburger} alt="menu" />
              </MenuBox>
            </TopRow>
            <TextView
              style={{
                fontWeight: "600",
                margin: "10px",
                marginBottom: "4px",
                fontSize: "20px",
                color: colors.primary,
              }}
            >
              Gallery
            </TextView>
            <GalleryLoader />
          </>
        ) : (
          <Stack
            sx={{
              backgroundColor: "#F6F7F9",
              overflow: "auto",
              height: "100vh",
            }}
          >
            <Sidebar
              // wheel_name={wheel_name}
              authorProfile={data?.user_profile}
              referral_code={referral_code}
              open={open}
              onClose={toggleSideBar}
              isProfile={true}
            />
            <TopRow>
              <Logo alt="logo" src={ASSETS.MobileLogo} />
              <MenuBox onClick={toggleSideBar}>
                <img src={ASSETS.Hamburger} alt="menu" />
              </MenuBox>
            </TopRow>
            <TextView
              style={{
                fontWeight: "600",
                margin: "10px",
                marginBottom: "4px",
                fontSize: "20px",
                color: colors.primary,
              }}
            >
              Gallery
            </TextView>
            {/* <CarouselContainer>
              <Carousel autoPlay={false}>
                <ProfileCard profileData={profileData} />
                <Preview1 businessBoxData={initialValues} />
                <Preview2 businessBoxData={initialValues} />
              </Carousel>
            </CarouselContainer> */}
            <Stack mx={1.5} mt={1}>
              <ProfileCard profileData={profileData} />
              {/* <MobileError /> */}
            </Stack>

            <MainWheel
              wheelType={wheelType}
              mainName={mainName}
              authorName={authorName}
              data={data}
              isEditable={false}
              handleCloneWheel={handleCloneWheel}
              onShareClick={() => {
                setOpenClipboard(true);
                navigator.clipboard.writeText(
                  window.location.origin + "/wheel/" + data?.id
                );
              }}
            />
            <Box
              style={{ zIndex: 1000 }}
              onClick={(event) => {
                event.stopPropagation(); // Stops the event from propagating further
              }}
            >
              <SearchContainer
                onClick={(event) => {
                  event.stopPropagation(); // Stops the event from propagating further
                }}
              >
                <SearchIcon src={ASSETS.search} />
                <TextInput
                  onChange={(e) => {
                    setSearchText(e.target.value);
                  }}
                  placeholder="Search wheels on gallery"
                  value={searchText}
                />
              </SearchContainer>
            </Box>

            <AllWheels
              publicWheels={filteredPublicWheels}
              onShareClick={(id) => {
                setOpenClipboard(true);
                navigator.clipboard.writeText(
                  window.location.origin + "/wheel/" + id
                );
              }}
            />
            <Snackbar
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={openClipboard}
              autoHideDuration={2000}
              onClose={handleClose}
              message={`Link copied to clipboard!`}
              action={
                <>
                  <IconButton
                    size="small"
                    aria-label="close"
                    color="inherit"
                    onClick={handleClose}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </>
              }
            />
          </Stack>
        )}
      </>
    );
  }
}

export default MobileView;
